/*
 * @Description:
 * @Date: 2019-01-15 17:21:38
 */
import Vue from 'vue';
import qs from 'qs'; // axios将JS对象序列化为JSON 需要QS重新编码
import store from '@/store/index';
import router from '@/router/index';
import Config from '@/config/index';

const ajaxWhileList = ['/login/auth'];
let loginError = [];
const dontInterceptSet = new Set(
  ['/industryProject/batchConfirmProject'].map(url => `/rest/gongye/saas${url}`)
);
export default () => {
  //发起拦截器
  // Vue.http.defaults.withCredentials=true;

  /*
    501 无权限
  */
  Vue.prototype.$http.interceptors.request.use(
    function(config) {
      // 添加视频接口不定义header
      if (config.url != 'http://stream.yxvzb.com/Api/YiYang/addVideos') {
        config.headers[Config.token] = localStorage[Config.token] || '';
      }
      if (
        config.method === 'post' &&
        ![
          '/rest/gongye/saas/upload/fileUploadProjectBI',
          '/rest/gongye/saas/subaccountManagement/userProjectAddOrEdit'
        ].includes(config.url) &&
        !config.notUseQs
      ) {
        Vue.http.defaults.headers['Content-Type'] =
          'application/x-www-form-urlencoded;charset=UTF-8';
        config.data = qs.stringify(config.data);
      }
      // if (
      //   config.method === 'post' &&
      //   ['/rest/gongye/saas/subaccountManagement/userProjectAddOrEdit'].includes(config.url)
      // ) {
      //   Vue.http.defaults.headers['Content-Type'] =
      //     'application/json;charset=UTF-8';
      //   // config.data = qs.stringify(config.data);
      //   console.log(config);
      // }
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );
  //响应拦截器
  Vue.http.interceptors.response.use(
    function(response) {
      if (
        ajaxWhileList.indexOf(response.config.url) != -1 ||
        (response.config.data &&
          !(response.config.data instanceof FormData) &&
          response.config.data.includes('noInterceptor'))
      ) {
        return { ...response, pdata: response.data.data };
      } else {
        let resp = response.data;
        // || resp.status == -999
        if (
          resp.returnCode == 501 ||
          resp.status == 500 ||
          resp.status == -999
        ) {
          localStorage.clear(); //todo
          router.push({ path: '/login' });
          if (loginError.length) {
            return false;
          } else {
            loginError.push(1);
            Vue.prototype.$notify({
              title: '失败',
              message: `登陆过期，请重新登陆`,
              type: 'error'
            });
            setTimeout(() => {
              location.reload(); //todo
            }, 300);
          }
        } else {
          if (
            (resp.status && resp.status == 1) ||
            resp.code == 200 ||
            dontInterceptSet.has(response.config.url)
          ) {
            store.commit('SET_BTLOADING', false);
            return { ...response, pdata: resp.data };
          } else if (resp.status === undefined) {
            // 文件下载无status
            return response;
          } else {
            let msg = resp.message || resp.returnMsg || '服务器异常';
            Vue.prototype.$notify({
              title: '失败',
              message: `${msg}`,
              type: 'error'
            });
            store.commit('SET_BTLOADING', false);
            return Promise.reject(resp);
          }
        }
      }
    },
    function(error) {
      store.commit('SET_BTLOADING', false);
      Vue.prototype.$notify({
        title: '失败',
        message: `网络出现错误请您检查网络情况`,
        type: 'error'
      });
      return Promise.reject(error);
    }
  );
};
